<template>
  <!-- Importing Lead SignIn Component -->
  <SignInForm></SignInForm>
</template>
<script>
import SignInForm from "../../components/Auths/SignIn.vue";
import { mapState } from "vuex";
export default {
  name: "Sign In View",
  components: { SignInForm },
  computed: mapState(["leadData"]),
  mounted() {
    if (this.leadData.length != 0) {
      this.$router.push("/application");
    }
  },
};
</script>
